import classNames from 'classnames/bind';

import styles from './S02.module.scss';

const cx = classNames.bind(styles);

const S02 = () => {
  return (
    <div className={cx('container')}>
      <div className={cx('limiter')}>
        <h2 className={cx('title')}>깊은 자연의 기술, 풀무원샘물</h2>
        <div className={cx('videoWrapper')}>
          <iframe
            src="https://www.youtube.com/embed/GR7QPQhDfcI?si=ADHP5yiwYZLHtuF0"
            title="YouTube video player"
            allowFullScreen
            className={cx('video')}></iframe>
        </div>
      </div>
    </div>
  );
};

export default S02;
